import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Integration_Overview extends PureComponent {
  render() {
    return (
      <div className="row" id="integration_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Integration Overview</h2>
              <p>
                The Nexoid platform is a modern RestAPI application making it
                extremely easy to integrate with. We also offer webhook events
                and custom inbound calls.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Integration_Overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/integration/Integration_Overview.js